export default "__VITE_ASSET__oVhxDwxg__"